import {Routes} from '@angular/router';
import {unlockedGuard} from '../guards/unlocked.guard';
import {backendGuard} from '../guards/backend.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'locked',
    pathMatch: 'full'
  },
  {
    path: 'locked',
    loadComponent: () => import('../layouts/locked/locked.layout').then(l => l.LockedLayout),
    loadChildren: () => import('../routes/locked.routes').then(r => r.lockedRoutes)
  },
  {
    path: '',
    loadComponent: () => import('../layouts/main/main.layout').then(l => l.MainLayout),
    loadChildren: () => import('../routes/main.routes').then(r => r.mainRoutes),
    canActivateChild: [unlockedGuard, backendGuard]
  },
  {
    path: 'tasks/:taskUuid',
    loadComponent: () => import('../pages/task/task.page').then(p => p.TaskPage),
    canActivate: [unlockedGuard, backendGuard]
  },
  {
    path: 'tasks/:taskUuid/related-tasks',
    loadComponent: () => import('../pages/related-tasks/related-tasks.page').then(p => p.RelatedTasksPage),
    canActivate: [unlockedGuard, backendGuard]
  },
  {
    path: 'move-annotations/:taskUuid',
    loadComponent: () => import('../pages/move-annotations-page/move-annotations-page.component').then(p => p.MoveAnnotationsPageComponent),
    canActivate: [unlockedGuard, backendGuard]
  },
  {
    path: '**',
    redirectTo: 'locked',
    pathMatch: 'full'
  }

];
